import React, { Component } from 'react';

import RankedPlayerItem from './RankedPlayerItem';
import TabFilters from './TabFilters';
import GetRatedCta from './GetRatedCta';
import { LinkAnchor } from '../Links';

import styles from './rankingList.module.scss';

class RankingList extends Component {
    constructor(props) {
        super(props);
        this.handleGenderChange = this.handleGenderChange.bind(this);
        this.handleTabChange = this.handleTabChange.bind(this);
        this.handleShowAllClicked = this.handleShowAllClicked.bind(this);
    }

    handleGenderChange(selectedGender) {
        if (this.props.onGenderChanged) this.props.onGenderChanged(selectedGender.selectedTab.value);
    }

    handleTabChange(tabState) {
        if (this.props.onTabChanged) this.props.onTabChanged(tabState);
    }

    handleShowAllClicked(e) {
        e.preventDefault();
        if (this.props.onShowAllClicked) this.props.onShowAllClicked();
    }

    renderLoading(count) {
        const items = [];
        for (let i = 0; i < count; i += 1) {
            items.push(
                <div key={i}>
                    <RankedPlayerItem
                        loading
                    />
                </div>,
            );
        }
        return <div>{items}</div>;
    }

    render() {
        const { title, subtitle, hideTitle, className, tabOptions, showThirdPartyRanking, loading, displayCount, players, showGetRated, playerLevel, hideFooter, footerTitle, filter, gender, ranking, rating, playerLinkRedirectValue } = this.props;
        return (
            <div className={`${styles.homeTopRankings} ${className}`}>
                <div className="container">
                    <div className={`mt56`}>
                        <div className={`hp-title ${hideTitle ? 'd-none' : 'd-block'}`}>
                            <h3>{title}</h3>
                            {subtitle && <p className="text-small">{subtitle}</p>}
                        </div>
                        <div className={`${styles.rankWrapper}`}>
                            {tabOptions && <TabFilters columnStyle={'col-12 text-center'} tabOptions={tabOptions} tabHeaderClass={styles.topHeader} onTabChange={this.handleTabChange} />}
                            <TabFilters
                                columnStyle={`col-7 text-left`}
                                tabOptions={{
                                    tabs: [{ name: 'MEN', value: 'm', default: true }, { name: 'WOMEN', value: 'f' }],
                                }}
                                filter={filter}
                                tabHeaderClass={styles.bb}
                                onTabChange={this.handleGenderChange}
                                tabHeaderChildren={(
                                    <>
                                        <div className={`col-2 ${showThirdPartyRanking ? 'col-sm-1' : 'col-sm-2'} text-center ${styles.rankHeaderColumn}`}>UTR</div>
                                        <div className={`col-3 ${showThirdPartyRanking ? 'col-sm-2' : 'col-sm-3'} text-center ${styles.rankHeaderColumn}`}>3 Mo.<span className="d-none d-md-inline">Trend</span></div>
                                        <div className={`col-1 d-none ${showThirdPartyRanking ? 'd-sm-block' : ''} text-center ${styles.rankHeaderColumn}`}>{gender === 'm' ? 'ATP' : 'WTA'}</div>
                                        <div className={`col-1 d-none ${showThirdPartyRanking ? 'd-sm-block' : ''} text-center ${styles.rankHeaderColumn}`} />
                                    </>
                                )}
                            />
                            <div>
                                {(players && players.length > 0) && !loading && players.slice(0, displayCount).map(player => {
                                    return (
                                        <LinkAnchor href={playerLinkRedirectValue ? `app:/profiles/${player.id}${playerLinkRedirectValue}` : `app:/profiles/${player.id}`} key={player.id}>
                                            <RankedPlayerItem
                                                {...player}
                                                showThirdPartyRanking={showThirdPartyRanking}
                                                playerLevel={playerLevel}
                                                ranking={ranking(player)}
                                                rating={rating(player)}
                                            />
                                        </LinkAnchor>
                                    );
                                })}
                                {((players && players.length > 0) && !loading) && (
                                    <React.Fragment>
                                        {showGetRated && (
                                            <GetRatedCta />
                                        )}
                                        {!hideTitle && !hideFooter && (
                                            <div className={`row ${styles.rankHeaders} ${styles.footer}`}>
                                                <div className={`col ${styles.rankHeaderColumn} text-left`}>
                                                    <a className={styles.footerLink} onClick={this.handleShowAllClicked}>
                                                        {footerTitle}
                                                    </a>
                                                </div>
                                            </div>
                                        )}
                                    </React.Fragment>
                                )}
                                {((players && players.length === 0) || loading) &&
                                    this.renderLoading(displayCount)}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default RankingList;
